import ActionTypeServicio from "../ActionTypeServicio";
import {ModosOp} from '../../../../isp._comun/iu/_principal/constantesIuPrin'// import Estado from '../../EstadoDialogoClienteAFacturar'

export default class CargaDeServicioActualizado extends ActionTypeServicio {
    ejecutar(estado, nuevoEstado) {
        // nuevoEstado.domain.idCliente = this.payload.idCliente;
        // nuevoEstado.domain.fechaReg = this.payload.fechaReg;
        // nuevoEstado.domain.estado = this.payload.estado;
        nuevoEstado.flag.procesandoComando = false;
        nuevoEstado.flag.modoOperacion = ModosOp.OK;

        for (const property in nuevoEstado.error) {
            nuevoEstado.error[property] = false;
        }

        // Estado.Registrado = estado.domain;
        // Estado.ParaUpdate={};
        nuevoEstado.domain.cargado = estado.domain.screen;
        nuevoEstado.domain.update = {};
        nuevoEstado.domain.nroUpdates = 0;

        return nuevoEstado;
    }
}
